import OfferHeader from './OfferHeader';

export default OfferHeader;
